import { Skeleton } from "@mui/material";
import { useGeneralProfileData } from "@/lib/profile/generalProfileData";

export default function GeneralProfileSkeleton() {
  const {
    isDarkMode,
  } = useGeneralProfileData();

  const skeletonSx = { bgcolor: isDarkMode ? "grey.800" : "", height: 50 };

  return (
    <div className="space-y-6">
      <div>
        <Skeleton
          animation="wave"
          variant="text"
          width={200}
          height={32}
          className="mb-4"
          sx={skeletonSx}
        />
        {/* Profile Photo */}
        <div className="mb-6">
          <Skeleton
            animation="wave"
            variant="text"
            width={180}
            height={24}
            sx={skeletonSx}
          />
          <div className="mt-2 flex items-center gap-4">
            <div className="flex items-center gap-4">
              <Skeleton
                animation="wave"
                variant="circular"
                width={70}
                height={70}
                sx={skeletonSx}
              />
              <Skeleton
                animation="wave"
                variant="text"
                width={130}
                height={50}
                sx={skeletonSx}
              />
            </div>
          </div>
        </div>

        <div className=" mb-6 grid grid-cols-1">
          <div className="mb-2">
            <Skeleton
              animation="wave"
              variant="text"
              width={160}
              height={20}
              sx={skeletonSx}
            />
          </div>
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={40}
            sx={skeletonSx}
          />
        </div>

        <div className="mb-6">
          <div className="mb-2">
            <Skeleton
              animation="wave"
              variant="text"
              width={160}
              height={20}
              sx={skeletonSx}
            />
          </div>
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={40}
            sx={skeletonSx}
          />
        </div>
      </div>

      <div className="mb-6">
        <div className="mb-2">
          <Skeleton
            animation="wave"
            variant="text"
            width={160}
            height={20}
            sx={skeletonSx}
          />
        </div>
        <Skeleton
          animation="wave"
          variant="rectangular"
          height={40}
          sx={skeletonSx}
        />
      </div>
      {/* Save Button */}
      < div className="flex justify-end pt-4 border-t border-gray-200" >
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={140}
          height={40}
          className="rounded"
          sx={skeletonSx}
        />
      </div >
    </div >
  );
}
